import React, {useCallback, useEffect, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import {useForm} from "react-hook-form";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Collapse from "@material-ui/core/Collapse";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Typography from "@material-ui/core/Typography";
import Dropzone from 'react-dropzone';
import {cloneDeep, fill, isEqual} from 'lodash';

import {apollo_useStyles,} from "../../../atom/Apollo_styles";
import {APOLLO_GROUP_OPERATOR, APOLLO_SYSTEM_ADMIN, IsAuthorization} from "../../../atom/Apollo_Authorization";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {ApolloMessage} from "../../../atom/Apollo_Mesasge";
import {
    ApolloBasicCheck,
    ApolloBasicRadio,
    ApolloBasicSelect,
    ApolloBasicTextField
} from "../../../molecule/Apollo_BaseItem";
import {
    AdAssetBoxLabel,
    AdAssetColor,
    AdAssetCommonItemParts,
    AdAssetCustomItemParts,
    AdAssetDisableEditMessage,
    AdAssetFormatId,
    AdAssetImageLimitSize,
    AdAssetImageType,
    AdAssetLabelFormatId,
    AdAssetProcessType,
    AdAssetSingleItemParts,
    ButtonLabelDelete,
    CommonItems,
    CustomItems,
    ImageDropZoneMessage,
    ImageItem,
    InitAdAsset,
    initCustomItems,
    initSectionItem,
    SectionItem,
    SingleItems,
    TextItem,
    TextLinkItem,
} from "./common/AdAssetModel";
import {CardHeader} from "@material-ui/core";
import AdAssetPreview from "./AdAssetsPreviewParts";
import {
    apollo_account_path,
    crassetsms_path,
    get_ms_asset_path,
    post_ms_asset_path,
    put_ms_asset_path
} from "../../../atom/Apollo_links";
import {ErrorMessage} from "@hookform/error-message";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {ApolloAxios} from "../../../atom/Apollo_ApiRequest3";
import {AdGroupProcessType, RESULT_ACCOUNT_ERROR} from "../../ADGROUP/ms/common/CommonConst";
import {
    BLANK,
    MSG,
    options_ms_asset_text_pos,
    options_ms_button_color,
    options_ms_button_label,
    options_ms_line_color,
    PREFIX_REQUEST_PARAM,
    RESULT_KBN,
    TEXT_VALID_PATTERN,
    URL_VALID_CHAR_PATTERN,
    URL_VALID_START_PATTERN_START,
} from "./common/CommonConst";
import {
    checkCommonInvalidTabChar, checkInvalidTabCharForImageFileName,
    checkInvalidTabCharsForName, checkUrlStrWithLength,
    convertBrTag,
    encodeInvalidChar, getSubjectStrCheckErrorMsgForTabChar, getTextStrCheckErrorMsgForTabChar,
    replaceMacroStr
} from "../../../common/Apollo_CommonUtil";
import {
    ApolloEventRecord,
    createLogDate,
    createUserLogItemListFromCheck,
    createUserLogItemListFromOptionValue,
    createUserLogItemListFromPictureFile,
    createUserLogItemListFromRadioValues,
    createUserLogItemListFromString,
    ItemList,
    LogData
} from "../../../atom/Apollo_EventRecord";
import {AdProcessType} from "../../ADVERTISEMENT/ms/common/CommonConst";
import moment from "moment";

type LogRecord = {
    commonItem: CommonItems,
    imageItem: ImageItem,
    textLinkItem1: TextLinkItem,
    textItem: TextItem,
    textLinkItem2: TextLinkItem,
    lineColor: string,
    sectionItems: SectionItem[],
    pictureFiles: File[],
}

interface AdAssetsEditProps {
    accountGrpId: number;
    accountId: number;
    platformaccountid: number;
    assetId: number;
    processType?: string;
    listReloadFunc ? : any;
}

const itemStyle = {
    marginBottom: "20px",
}

export const apollo_msStyles = makeStyles({
    item: {
        marginBottom: "500px",
    },

    textHiHighlightingRed: {
        color: "red",
        fontSize: 20,
        whiteSpace: "normal",
    },
});

const checkMessageRequired = "必須入力項目です。"
const checkMessageTextMaxLength20 = "20文字以内で入力して下さい。"
const checkMessageTextMaxLength30 = "30文字以内で入力して下さい。"
const checkMessageTextMaxLength90 = "90文字以内で入力して下さい。"
const checkMessageTextMaxLength180 = "180文字以内で入力して下さい。"
const checkMessageTextMaxLength255 = "255文字以内で入力して下さい。"
const checkMessageTextInvalidPattern = "禁止文字が含まれます。"

const checkValueMaxLength20 = 20
const checkValueMaxLength30 = 30
const checkValueMaxLength90 = 90
const checkValueMaxLength180 = 180
const checkValueMaxLength255 = 255

/*
    画面名：広告アセット作成・編集・複製（MS）
 */
const AdAssetsEdit: React.FC<AdAssetsEditProps> = (
    {
        accountGrpId,
        accountId,
        platformaccountid,
        assetId,
        processType,
        listReloadFunc,
    }) => {

    // style
    const classes = apollo_useStyles();
    const msClasses = apollo_msStyles();

    // history
    const history = useHistory();
    const handelGoback = () => {
        history.goBack();
    };

    // useContext
    const {state: apolloContex} = React.useContext(ApolloContext);
    const {data: msg, setmsg} = React.useContext(ApolloMessage);

    // form
    const {register, handleSubmit, control, errors, formState, setError} = useForm({reValidateMode: 'onBlur'});

    //    common
    const [commonItems, setCommonItems] = useState<CommonItems>(InitAdAsset.mailData.commonItems)

    //    single
    const [imageItem, setImageItem] = useState<ImageItem>(InitAdAsset.mailData.singleItems.imageItem)
    const [textLinkItem1, setTextLinkItem1] = useState<TextLinkItem>(InitAdAsset.mailData.singleItems.textLinkItem1)
    const [textItem, setTextItem] = useState<TextItem>(InitAdAsset.mailData.singleItems.textItem)
    const [textLinkItem2, setTextLinkItem2] = useState<TextLinkItem>(InitAdAsset.mailData.singleItems.textLinkItem2)

    //    custom
    const [lineColor, setLineColor] = useState<string>(InitAdAsset.mailData.customItems.lineColor)
    const [sectionItems, setSectionItems] = useState<SectionItem[]>(InitAdAsset.mailData.customItems.sectionItems)

    const [pictureFiles, setPictureFiles] = useState<File[]>([null as any, null as any, null as any, null as any])
    const [pictureFileSizeList, setPictureFileSizeList] = useState([0, 0, 0, 0])

    const disableEdit = useRef(false);
    const beforeEditRecord = useRef<LogRecord | null>(null);
    const processing = useRef(false);

    // function
    const goBack = () => {
        processType === AdAssetProcessType.create ?
            history.push(`${crassetsms_path}${accountGrpId}/${accountId}/${platformaccountid}`) :
            listReloadFunc && listReloadFunc()
    };


    useEffect(() => {

        if (processType === AdAssetProcessType.create) {
            const urlAccount = `${process.env.REACT_APP_API_ENDPOINT}${apollo_account_path}/${accountGrpId}/${accountId}`
            const fetchData = async () => {
                ApolloAxios.get(urlAccount,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${apolloContex.accesstoken}`,
                        },
                    })
                    .then((response) => {
                        if (response.data?.resultCode === RESULT_ACCOUNT_ERROR) {
                            setmsg({
                                type: "setMessage",
                                payload: {
                                    ...msg,
                                    open: true,
                                    type: "error",
                                    message: `${MSG.ERR_GET_ACCOUNT}${response?.data?.message ?? BLANK}`
                                }
                            });
                        } else {
                            const notation = response.data?.result["advertiserName"] ?? BLANK;
                            setCommonItems({...commonItems, notation: notation});
                        }
                    }).catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_ACCOUNT}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
            };

            fetchData();

        } else if (processType === AdAssetProcessType.edit || processType === AdAssetProcessType.copy) {

            const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_asset_path}/${platformaccountid}/${assetId}`;
            const fetchData = async () => {
                await ApolloAxios.get(
                    url,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${apolloContex.accesstoken}`,
                        }
                    }
                ).then(response => {

                    if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                        const adAsset = response.data.adAsset
                        const formatId = adAsset.formatId
                        const adAssetName = processType === AdAssetProcessType.copy ? BLANK : adAsset.mailData.commonItems.assetName
                        const buttonLinkItem = {
                            ...adAsset.mailData.commonItems.buttonLinkItem,
                            colorType: adAsset.mailData.commonItems.buttonLinkItem.colorType || AdAssetColor.green.label,
                        }

                        let commonItemsLocal = InitAdAsset.mailData.commonItems
                        let imageItemLocal = InitAdAsset.mailData.singleItems.imageItem
                        let textLinkItem1Local = InitAdAsset.mailData.singleItems.textLinkItem1
                        let textItemLocal = InitAdAsset.mailData.singleItems.textItem
                        let textLinkItem2Local = InitAdAsset.mailData.singleItems.textLinkItem2
                        let lineColorLocal = InitAdAsset.mailData.customItems.lineColor
                        let sectionItemsLocal = InitAdAsset.mailData.customItems.sectionItems
                        let pictureFilesLocal = [null as any, null as any, null as any, null as any]

                        if (processType === AdAssetProcessType.edit) {
                            disableEdit.current = adAsset.creativeIds.length > 0 ? true : false
                            commonItemsLocal = {
                                ...adAsset.mailData.commonItems,
                                assetName: adAssetName,
                                buttonLinkItem: buttonLinkItem,
                                lastUpdatedVer: adAsset.lastUpdatedVer,
                            }
                            setCommonItems(commonItemsLocal)
                        } else if (processType === AdAssetProcessType.copy) {
                            commonItemsLocal = {
                                ...adAsset.mailData.commonItems,
                                buttonLinkItem: buttonLinkItem,
                                assetName: adAssetName
                            }
                            setCommonItems(commonItemsLocal)
                        }

                        if (formatId === AdAssetFormatId.single) {
                            imageItemLocal = adAsset.mailData.singleItems.imageItem
                            textLinkItem1Local = adAsset.mailData.singleItems.textLinkItem1
                            textLinkItem2Local = adAsset.mailData.singleItems.textLinkItem2
                            textItemLocal = adAsset.mailData.singleItems.textItem

                            setImageItem(imageItemLocal)
                            setTextLinkItem1(textLinkItem1Local)
                            setTextLinkItem2(textLinkItem2Local)
                            setTextItem(textItemLocal)
                            setPictureFileSizeList([adAsset.mailData.singleItems.imageItem.imageSize, 0, 0, 0].map(v => v))
                        } else if (formatId === AdAssetFormatId.custom) {
                            lineColorLocal = adAsset.mailData.customItems.lineColor ? adAsset.mailData.customItems.lineColor : initCustomItems.lineColor
                            sectionItemsLocal = getNewSectionItems(adAsset.mailData.customItems.sectionItems)

                            setLineColor(lineColorLocal)
                            setSectionItems(sectionItemsLocal)
                            setPictureFileSizeList(adAsset.mailData.customItems.sectionItems.map((value: any) => value.imageSize))
                        }

                        beforeEditRecord.current = {
                            commonItem: cloneDeep(commonItemsLocal),
                            imageItem: cloneDeep(imageItemLocal),
                            textLinkItem1: cloneDeep(textLinkItem1Local),
                            textItem: cloneDeep(textItemLocal),
                            textLinkItem2: cloneDeep(textLinkItem2Local),
                            lineColor: lineColorLocal,
                            sectionItems: cloneDeep(sectionItemsLocal),
                            pictureFiles: cloneDeep(pictureFilesLocal),
                        }

                    } else {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_ADASSET}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                }).catch(err => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_ADASSET}${err?.errmsg ?? BLANK}`
                        }
                    });
                });
            };
            fetchData();
        }
    }, [])

    const onSubmit = handleSubmit(async (formData: any) => {

                let isSuccess = false;

                if (formState.isSubmitting) return;
                if (processing.current) return;

                let hasErr = false

                const totalImageSize = pictureFileSizeList.reduce(function (sum, element) {
                    return sum + (element ? element : 0);
                }, 0);

                if (totalImageSize > AdAssetImageLimitSize.TOTALMAXTBYTE) {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `画像ファイルの合計が${totalImageSize.toLocaleString()}バイトです。691,200バイト（675キロバイト）以下となるように設定してください。`
                        }
                    });
                    return
                }

                if (commonItems.formatId === AdAssetFormatId.single) {

                    if (imageItem.imageUrl === "") {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: "画像ファイルを設定してください。"
                            }
                        });
                        return
                    }

                    [textLinkItem1, textLinkItem2].map((elem, index) => {
                        if ((elem.text !== BLANK) && (elem.transitionUrl === BLANK)) {
                            setError(`${AdAssetSingleItemParts.transitionUrlForTextLink.id}${index + 1}`, {
                                type: "manual",
                                message: 'テキストが入力されている場合、入力必須となります。'
                            })
                            hasErr = true
                        } else if ((elem.text === BLANK) && (elem.transitionUrl !== BLANK)) {
                            setError(`${AdAssetSingleItemParts.textLink.id}${index + 1}`, {
                                type: "manual",
                                message: '遷移先URLが入力されている場合、入力必須となります。'
                            })
                            hasErr = true
                        }
                    })
                    if (hasErr) return

                } else if (commonItems.formatId === AdAssetFormatId.custom) {

                    if (sectionItems.filter(value => value.imageUrl !== BLANK).length === 0) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: "画像ファイルは1つ以上設定してください。"
                            }
                        });
                        return
                    }

                    if (sectionItems.map((elem, index) => {
                        if (elem.textLink !== BLANK && elem.imageUrl !== BLANK) {
                            setError(`${AdAssetCustomItemParts.textLinkForSection.id}${index + 1}`, {
                                type: "manual",
                                message: '画像とテキストリンクはどちらか一方を設定してください。'
                            })
                            return false
                        } else {
                            return true
                        }
                    }).filter(elem => !elem).length > 0) return

                    if (sectionItems.map((elem, index) => {
                        if ((elem.textLink !== BLANK || elem.imageUrl !== BLANK) && (elem.transitionUrl === BLANK)) {
                            setError(`${AdAssetCustomItemParts.transitionUrlForSection.id}${index + 1}`, {
                                type: "manual",
                                message: '画像、またはテキストリンクが入力されている場合、入力必須となります。'
                            })
                            return false
                        } else if ((elem.textLink === BLANK && elem.imageUrl === BLANK) && (elem.transitionUrl !== BLANK)) {
                            setError(`${AdAssetCustomItemParts.transitionUrlForSection.id}${index + 1}`, {
                                type: "manual",
                                message: '遷移先URLが入力されている場合、画像、またはテキストリンクは入力必須となります。'
                            })
                            return false
                        }
                        return true
                    }).filter(elem => !elem).length > 0) return

                }

                if (commonItems.buttonLinkItem.labelType !== BLANK) {
                    if (commonItems.buttonLinkItem.transitionUrl === BLANK) {
                        setError(AdAssetCommonItemParts.linkButtonTransitionUrl.id, {
                            type: "manual",
                            message: '表示ラベルが選択されているため、入力必須となります。'
                        })
                        return
                    }
                }

                if (commonItems.buttonLinkItem.transitionUrl !== BLANK) {
                    if (commonItems.buttonLinkItem.labelType === BLANK) {
                        setError(AdAssetCommonItemParts.linkButtonLabel.id, {
                            type: "manual",
                            message: '遷移先URLが選択されているため、選択必須となります。'
                        })
                        return
                    }
                }

                if (commonItems.buttonLinkItem.labelType === BLANK) {
                    if (commonItems.buttonLinkItem.colorType !== BLANK && commonItems.buttonLinkItem.colorType !== AdAssetColor.green.label) {
                        setError(AdAssetCommonItemParts.linkButtonLabel.id, {
                            type: "manual",
                            message: 'カラーが選択されているため、入力必須となります。'
                        })
                        return
                    }
                }

                const mailData = {
                    commonItems: commonItems,
                    singleItems: {
                        imageItem: imageItem,
                        textLinkItem1: textLinkItem1,
                        textLinkItem2: textLinkItem2,
                        textItem: textItem,
                    },
                    customItems: {
                        lineColor: lineColor,
                        sectionItems: sectionItems,
                    },
                }

                processing.current = true;

                const editLogInfo = createUserLog(
                    apolloContex,
                    "メール広告",
                    "広告アセット",
                    processType ?? BLANK,
                    processType === AdProcessType.create ? "広告アセット（MS）作成" :
                        processType === AdProcessType.edit ? "広告アセット（MS）編集" : "広告アセット（MS）複製",
                    processType === AdProcessType.edit ? beforeEditRecord.current : null,
                    {
                        commonItem: commonItems,
                        imageItem: imageItem,
                        textLinkItem1: textLinkItem1,
                        textItem: textItem,
                        textLinkItem2: textLinkItem2,
                        lineColor: lineColor,
                        sectionItems: sectionItems,
                        pictureFiles: pictureFiles,
                    },
                    {
                        textPosType: options_ms_asset_text_pos,
                        labelType : options_ms_button_label,
                        colorType : options_ms_button_color,
                        lineColor : options_ms_line_color,
                    },
                )

                ApolloEventRecord({...editLogInfo, logType: "execute"})

                if (processType === AdAssetProcessType.create || processType === AdAssetProcessType.copy) {

                    // path
                    const url = `${process.env.REACT_APP_API_ENDPOINT}${post_ms_asset_path}/${platformaccountid}`;

                    // createParam
                    const params = new FormData();
                    params.append('adAccountId', platformaccountid.toString());
                    params.append('mailData', JSON.stringify(mailData));

                    if (commonItems.formatId === AdAssetFormatId.single) {
                        params.append('pictureFile1', pictureFiles[0]);
                    } else if (commonItems.formatId === AdAssetFormatId.custom) {
                        for (let i = 0; i < pictureFiles.length; i++) {
                            if (pictureFiles[i]) {
                                params.append(`pictureFile${i + 1}`, pictureFiles[i]);
                            }
                        }
                    }

                    params.append('userId', apolloContex.userprofile.userId.toString());
                    params.append('sourceAdAssetId', assetId.toString());

                    const {successMsg, errorMsg} = processType === AdAssetProcessType.create ?
                        {
                            successMsg: MSG.SUCCESS_POST_ADASSET,
                            errorMsg: MSG.ERR_POST_ADASSET,
                        }
                        : {
                            successMsg: MSG.SUCCESS_COPY_ADASSET,
                            errorMsg: MSG.ERR_COPY_ADASSET,
                        }

                    let registedId = BLANK

                    await ApolloAxios.post(
                        url,
                        params,
                        {
                            headers: {
                                'Authorization': `Bearer ${apolloContex.accesstoken}`,
                            }
                        })
                        .then((response) => {
                            if (response.data.resultcode == RESULT_KBN.SUCCESS) {
                                registedId = response.data.registedId?.toString() ?? BLANK
                                isSuccess = true;
                                setmsg({
                                    type: "setMessage",
                                    payload: {
                                        ...msg,
                                        open: true,
                                        type: "success",
                                        message: successMsg
                                    }
                                });
                            } else {
                                setmsg({
                                    type: "setMessage",
                                    payload: {
                                        ...msg,
                                        open: true,
                                        type: "error",
                                        message: `${errorMsg}${response?.data?.message ?? BLANK}`
                                    }
                                });
                            }
                        })
                        .catch((err) => {
                            setmsg({
                                type: "setMessage",
                                payload: {
                                    ...msg,
                                    open: true,
                                    type: "error",
                                    message: `${errorMsg}${err?.errmsg ?? BLANK}`
                                }
                            });
                        }).finally(() => {
                            processing.current = false;
                            const eventRecords: LogData = {
                                ...editLogInfo,
                                eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                                targetID: registedId,
                                targetName: commonItems.assetName,
                                logType: "result",
                                result: isSuccess ? "成功" : "失敗"
                            }
                            ApolloEventRecord(eventRecords)
                            if(isSuccess) goBack()
                        });

                } else if (processType === AdAssetProcessType.edit) {

                    // path
                    const url = `${process.env.REACT_APP_API_ENDPOINT}${put_ms_asset_path}/${platformaccountid}/${assetId}`;

                    const mailData = {
                        commonItems: commonItems,
                        singleItems: {
                            imageItem: imageItem,
                            textLinkItem1: textLinkItem1,
                            textLinkItem2: textLinkItem2,
                            textItem: textItem,
                        },
                        customItems: {
                            lineColor: lineColor,
                            sectionItems: sectionItems,
                        },
                    }

                    // createParam
                    const params = new FormData();
                    params.append('adAccountId', platformaccountid.toString());
                    params.append('adAccountName', apolloContex.current.accountName);
                    params.append('adAssetId', assetId.toString());
                    params.append('mailData', JSON.stringify(mailData));

                    if (commonItems.formatId === AdAssetFormatId.single) {
                        params.append('pictureFile1', pictureFiles[0]);
                    } else if (commonItems.formatId === AdAssetFormatId.custom) {
                        for (let i = 0; i < pictureFiles.length; i++) {
                            if (pictureFiles[i]) {
                                params.append(`pictureFile${i + 1}`, pictureFiles[i]);
                            }
                        }
                    }

                    params.append('userId', apolloContex.userprofile.userId.toString());
                    params.append('lastUpdatedVer', commonItems.lastUpdatedVer);

                    await ApolloAxios.put(
                        url,
                        params,
                        {
                            headers: {
                                'Authorization': `Bearer ${apolloContex.accesstoken}`,
                            }
                        })
                        .then((response) => {
                            if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                                isSuccess = true;
                                setmsg({
                                    type: "setMessage",
                                    payload: {
                                        ...msg,
                                        open: true,
                                        type: "success",
                                        message: MSG.SUCCESS_PUT_ADASSET
                                    }
                                });
                                goBack()
                            } else if (response.data.resultcode === RESULT_KBN.ERROR) {
                                setmsg({
                                    type: "setMessage",
                                    payload: {
                                        ...msg,
                                        open: true,
                                        type: "error",
                                        message: `${MSG.ERR_PUT_ADASSET}${response?.data?.message ?? BLANK}`
                                    }
                                });
                            }
                        })
                        .catch((err) => {
                            setmsg({
                                type: "setMessage",
                                payload: {
                                    ...msg,
                                    open: true,
                                    type: "error",
                                    message: `${MSG.ERR_PUT_ADASSET}${err?.errmsg ?? BLANK}`
                                }
                            });
                        }).finally(() => {
                            processing.current = false;
                            const eventRecords: LogData = {
                                ...editLogInfo,
                                eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                                targetID: assetId.toString(),
                                targetName: commonItems.assetName,
                                logType: "result",
                                result: isSuccess ? "成功" : "失敗"
                            }
                            ApolloEventRecord(eventRecords)
                            if(isSuccess) goBack()
                        });
                }
            }
        )
    ;

    return (
        <React.Fragment>
            <form noValidate onSubmit={onSubmit}>
                <Card className={classes.root} square variant="outlined">
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                {disableEdit.current ?
                                    <p className={msClasses.textHiHighlightingRed}>{AdAssetDisableEditMessage}</p> : <></>}
                            </Grid>
                            <Grid item xs={7}>
                                <Grid container spacing={3}>
                                    {[
                                        //アセット名
                                        <ApolloBasicTextField
                                            id={AdAssetCommonItemParts.assetName.id}
                                            label={AdAssetCommonItemParts.assetName.label}
                                            value={commonItems.assetName}
                                            error={errors.assetName}
                                            required={true}
                                            inputRef={register({
                                                required: checkMessageRequired,
                                                maxLength: {
                                                    value: checkValueMaxLength255,
                                                    message: checkMessageTextMaxLength255
                                                },
                                                validate: (e: string) => {
                                                    const errorMessage = checkInvalidTabCharsForName(e)
                                                    if(errorMessage) {
                                                        return errorMessage
                                                    }},
                                            })}
                                            setState={(e: any) => setCommonItems({...commonItems, assetName: e})}
                                        />,
                                        //件名
                                        <ApolloBasicTextField
                                            id={AdAssetCommonItemParts.subject.id}
                                            label={AdAssetCommonItemParts.subject.label}
                                            value={commonItems.subject}
                                            error={errors.subject}
                                            required={true}
                                            disabled={disableEdit.current}
                                            inputRef={register({
                                                required: checkMessageRequired,
                                                maxLength: {
                                                    value: checkValueMaxLength20,
                                                    message: checkMessageTextMaxLength20
                                                },
                                                validate: (value: string) => {
                                                    const errorMessage = getSubjectStrCheckErrorMsgForTabChar(value)
                                                    if(errorMessage) {
                                                        return errorMessage
                                                    }
                                                },
                                            })}
                                            setState={(e: any) => setCommonItems({...commonItems, subject: e})}
                                        />,
                                        // フォーマット種別
                                        <ApolloBasicRadio
                                            id={AdAssetCommonItemParts.formatId.id}
                                            label={AdAssetCommonItemParts.formatId.label}
                                            options={[
                                                {label: AdAssetLabelFormatId.single, value: AdAssetFormatId.single},
                                                {label: AdAssetLabelFormatId.custom, value: AdAssetFormatId.custom}
                                            ]}
                                            value={commonItems.formatId}
                                            disabled={processType === AdAssetProcessType.edit || processType === AdAssetProcessType.copy ? true : false}
                                            control={control}
                                            errors={errors}
                                            setState={(e: any) => {
                                                setCommonItems({...commonItems, formatId: Number(e)})
                                            }}/>,
                                        <Card className={classes.root} square variant="outlined">
                                            <CardContent>
                                                {/*テキスト表示位置*/}
                                                <Grid item xs={12} style={itemStyle}>
                                                    <ApolloBasicSelect
                                                        id={AdAssetCommonItemParts.textPos.id}
                                                        label={AdAssetCommonItemParts.textPos.label}
                                                        options={options_ms_asset_text_pos}
                                                        value={commonItems.textPosType}
                                                        disabled={disableEdit.current}
                                                        control={control}
                                                        errors={errors}
                                                        setState={(e: any) => setCommonItems({
                                                            ...commonItems,
                                                            textPosType: e
                                                        })}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} style={itemStyle}>
                                                    {
                                                        commonItems.formatId === AdAssetFormatId.single ?
                                                            /*シングルフォーマット　画像, テキストリンク1, テキスト本文, テキストリンク2　ボタンリンク*/
                                                            <SingleItemsContents
                                                                singleItems={
                                                                    {
                                                                        imageItem: imageItem,
                                                                        textLinkItem1: textLinkItem1,
                                                                        textItem: textItem,
                                                                        textLinkItem2: textLinkItem2,
                                                                    }
                                                                }
                                                                setState={{
                                                                    setImageItem: setImageItem,
                                                                    setTextLinkItem1: setTextLinkItem1,
                                                                    setTextItem: setTextItem,
                                                                    setTextLinkItem2: setTextLinkItem2,
                                                                }}
                                                                register={register}
                                                                errors={errors}
                                                                setError={setError}
                                                                disabled={disableEdit.current}
                                                                control={control}
                                                                uploadFile={{
                                                                    files: pictureFiles,
                                                                    setFiles: setPictureFiles,
                                                                    pictureFileSizeList: pictureFileSizeList,
                                                                    setPictureFileSizeList: setPictureFileSizeList,
                                                                }}

                                                            /> :
                                                            /*カスタムフォーマット　セクション1～セクション4,ボタンリンク*/
                                                            <CustomItemsContents
                                                                customItems={
                                                                    {
                                                                        lineColor: lineColor,
                                                                        sectionItems: sectionItems,
                                                                    }
                                                                }
                                                                setState={{
                                                                    setLineColor: setLineColor,
                                                                    setSectionItems: setSectionItems,
                                                                }}
                                                                register={register}
                                                                disabled={disableEdit.current}
                                                                errors={errors}
                                                                control={control}
                                                                uploadFile={{
                                                                    files: pictureFiles,
                                                                    setFiles: setPictureFiles,
                                                                    pictureFileSizeList: pictureFileSizeList,
                                                                    setPictureFileSizeList: setPictureFileSizeList,
                                                                }}
                                                            />
                                                    }
                                                </Grid>
                                                {/*リンクボタン*/}
                                                <Grid item xs={12} style={itemStyle}>
                                                    <AdAssetLinkButtonItem
                                                        commonItems={commonItems}
                                                        setCommonItems={setCommonItems}
                                                        disabled={disableEdit.current}
                                                        register={register}
                                                        errors={errors}
                                                        control={control}
                                                    />
                                                </Grid>
                                                {/*主体者表記*/}
                                                <Grid item xs={12} style={itemStyle}>
                                                    <ApolloBasicTextField
                                                        id={AdAssetCommonItemParts.notation.id}
                                                        label={AdAssetCommonItemParts.notation.label}
                                                        required={true}
                                                        value={commonItems.notation}
                                                        error={errors.notation}
                                                        disabled={disableEdit.current}
                                                        inputRef={register({
                                                            required: checkMessageRequired,
                                                            maxLength: {
                                                                value: checkValueMaxLength30,
                                                                message: checkMessageTextMaxLength30
                                                            },
                                                            pattern: {
                                                                value: TEXT_VALID_PATTERN,
                                                                message: checkMessageTextInvalidPattern,
                                                            },
                                                            validate: (value: string) => {
                                                                const errorMessage = getTextStrCheckErrorMsgForTabChar(value)
                                                                if(errorMessage) {
                                                                    return errorMessage
                                                                }
                                                            },
                                                        })}
                                                        setState={(e: any) => setCommonItems({
                                                            ...commonItems,
                                                            notation: e
                                                        })}
                                                    />
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    ].map((value) => {
                                        return (
                                            <Grid item xs={12}>
                                                {value}
                                            </Grid>
                                        )
                                    })
                                    }
                                </Grid>
                            </Grid>
                            {/*preview*/}
                            <Grid item xs={5}>
                                <AdAssetPreview {
                                                    ...{
                                                        mailData: {
                                                            commonItems: commonItems,
                                                            singleItems: {
                                                                imageItem: imageItem,
                                                                textLinkItem1: textLinkItem1,
                                                                textLinkItem2: textLinkItem2,
                                                                textItem: textItem,
                                                            },
                                                            customItems: {
                                                                lineColor: lineColor,
                                                                sectionItems: sectionItems,
                                                            }
                                                        },
                                                        pictureFile: []
                                                    }
                                                }
                                />
                            </Grid>

                        </Grid>
                    </CardContent>
                    <CardActions className={classes.cardaction}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            onClick={onSubmit}
                            className={classes.button}
                            disabled={formState.isSubmitting || !IsAuthorization(APOLLO_GROUP_OPERATOR, APOLLO_SYSTEM_ADMIN) || processing.current}
                        >
                            {processType === AdAssetProcessType.create ? "作成" :
                                processType === AdAssetProcessType.edit ? "更新" : "複製"
                            }
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={e => goBack()}
                            className={classes.button}
                            disabled={formState.isSubmitting || processing.current}
                        >
                            戻る
                        </Button>
                    </CardActions>
                </Card>
            </form>
        </React.Fragment>
    )
};

const SingleItemsContents: React.FC<{
    singleItems: SingleItems,
    setState: {
        setImageItem: any,
        setTextLinkItem1: any,
        setTextItem: any,
        setTextLinkItem2: any,
    },
    register: any,
    errors: any,
    setError: any,
    disabled: boolean,
    control: any,
    uploadFile: {
        files: any,
        setFiles: any,
        pictureFileSizeList: any,
        setPictureFileSizeList: any,
    }
}> = ({singleItems, setState, register, errors, setError, disabled, control, uploadFile}) => {

    return (
        <React.Fragment>
            {
                [
                    //画像
                    <AdAssetImageItem
                        imageItem={singleItems.imageItem}
                        setImageItem={setState.setImageItem}
                        disabled={disabled}
                        errors={errors}
                        setError={setError}
                        register={register}
                        uploadFile={uploadFile}
                    />,
                    //テキストリンク1
                    <AdAssetTextLinkItem
                        textLinkItem={singleItems.textLinkItem1}
                        setTextLinkItem={setState.setTextLinkItem1}
                        disabled={disabled}
                        register={register}
                        errors={errors}
                        index={1}
                    />,
                    //テキスト本文
                    <AdAssetTextItem
                        textItem={singleItems.textItem}
                        setTextItem={setState.setTextItem}
                        disabled={disabled}
                        register={register}
                        errors={errors}
                    />,
                    //テキストリンク2
                    <AdAssetTextLinkItem
                        textLinkItem={singleItems.textLinkItem2}
                        setTextLinkItem={setState.setTextLinkItem2}
                        disabled={disabled}
                        register={register}
                        errors={errors}
                        index={2}
                    />
                ].map((value) => {
                    return (
                        <Grid container style={{marginBottom: "30px"}}>
                            <Grid item xs={12}>
                                {value}
                            </Grid>
                        </Grid>
                    )
                })
            }
        </React.Fragment>)
}

const AdAssetCardContent: React.FC<{
    label: string,
    children: any,
    expandOption?: {
        isOpen: boolean,
        setState: any,
        isEdited: boolean,
    }
}> = ({label, children, expandOption}) => {
    const classes = apollo_useStyles();


    const title = expandOption ?
        (
            <Grid container>
                <Grid item xs={11}>
                    {`${label}: ${expandOption.isEdited ? "設定あり" : "未設定"}`}
                </Grid>
                <Grid item xs={1}>
                    <IconButton aria-label="expand row" size="small" onClick={() => {
                        expandOption.setState()
                    }}>
                        {expandOption.isOpen ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                    </IconButton>
                </Grid>
            </Grid>
        )
        : label

    const contens = expandOption ?
        <Collapse in={expandOption.isOpen} timeout="auto" unmountOnExit
                  style={{marginBottom: "5px"}}>{children}</Collapse> : children

    return (
        <Card className={classes.root}>
            <CardHeader
                style={{backgroundColor: "#EEE", padding: "3px", marginLeft: "5px"}}
                titleTypographyProps={{variant: "h6"}}
                title={title}
            />
            <CardContent>
                {contens}
            </CardContent>
        </Card>
    )
}

const AdAssetImageItem: React.FC<{
    imageItem: ImageItem,
    setImageItem: any,
    disabled: boolean,
    register: any,
    errors: any,
    setError: any,
    uploadFile: {
        files: any,
        setFiles: any,
        pictureFileSizeList: any,
        setPictureFileSizeList: any,
    },
}> = ({imageItem, setImageItem, register, disabled, errors, setError, uploadFile}) => {
    return (
        <AdAssetCardContent
            label={AdAssetBoxLabel.image}
            children={
                <React.Fragment>
                    <Grid container>
                        {
                            [
                                <AdImage
                                    id={AdAssetSingleItemParts.image.id}
                                    label={AdAssetSingleItemParts.image.label}
                                    imageUrl={imageItem.imageUrl}
                                    register={register}
                                    setState={(e: string) => {
                                        if (e === "") {
                                            setImageItem({...imageItem, imageUrl: e, imageName: e})
                                        } else {
                                            setImageItem({...imageItem, imageUrl: e})
                                        }
                                    }}
                                    disabled={disabled}
                                    errors={errors}
                                    setFiles={(e: any) => {
                                        uploadFile.setFiles(
                                            fill([...uploadFile.files], e, 0, 1)
                                        )
                                        uploadFile.setPictureFileSizeList(
                                            fill([...uploadFile.pictureFileSizeList], e !== null ? e.size : 0, 0, 1)
                                        )
                                    }}
                                />,
                                <ApolloBasicTextField
                                    id={AdAssetSingleItemParts.transitionUrlForImage.id}
                                    label={AdAssetSingleItemParts.transitionUrlForImage.label}
                                    value={imageItem.transitionUrl}
                                    error={errors.singleTransitionUrlForImage}
                                    inputRef={register({
                                        required: checkMessageRequired,
                                        validate: (value: string) => {
                                            const errorMsg = checkUrlStrWithLength(value)
                                            if (errorMsg) {
                                                return errorMsg
                                            }
                                            return checkCommonInvalidTabChar(value);
                                        }
                                    })}
                                    disabled={disabled}
                                    required={true}
                                    setState={(e: any) => setImageItem({
                                        ...imageItem,
                                        transitionUrl: e
                                    })}
                                />
                            ].map((value) => {
                                return (
                                    <Grid item xs={12}>
                                        {value}
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </React.Fragment>
            }
        />
    )
}


const AdImage: React.FC<{
    id: string,
    label: string,
    imageUrl: string,
    setState: any,
    register: any,
    disabled: boolean,
    errors: any,
    setFiles: any,

}> = ({id, label, imageUrl, setState, register, disabled, setFiles, errors}) => {
    const classes = apollo_useStyles();
    const reader = new FileReader();

    const {data: msg, setmsg} = React.useContext(ApolloMessage);

    const onDrop = useCallback(acceptedFiles => {

        const fileName = acceptedFiles[0].name
        const errorMessage = checkInvalidTabCharForImageFileName(fileName)
        if(errorMessage) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...msg,
                    open: true,
                    type: "error",
                    message: "画像ファイル名エラー：" + errorMessage
                }
            });
            return
        }

        if ([AdAssetImageType.GIF, AdAssetImageType.JPG, AdAssetImageType.JPEG].filter(elem => {
            const fileExtension = acceptedFiles[0].name?.split(".")
            const regexp = new RegExp("^" + elem + "$", "i")
            return regexp.test(fileExtension[fileExtension.length - 1])
        }).length === 0) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...msg,
                    open: true,
                    type: "error",
                    message: "画像ファイルは、jpg,jpeg,gifのいずれかのみ設定可能です。"
                }
            });
            return
        }

        reader.onload = () => {
            const datauri = reader.result as string;
            setState(datauri)
            setFiles(acceptedFiles[0])
            const img = new Image()
            img.addEventListener('load', () => {


            });
            img.src = datauri;
        }

        if (acceptedFiles[0]) {
            reader.readAsDataURL(acceptedFiles[0]);
        }
    }, [setState, setFiles])

    return (
        <React.Fragment>
            <Typography color="textSecondary" gutterBottom>
                {label}
            </Typography>
            <section className="container">
                {disabled ? <></> :
                    <Dropzone onDrop={e => onDrop(e)}>
                        {({getRootProps, getInputProps}) => (
                            <div {...getRootProps({className: "dropzone"})}>
                                <input {...getInputProps()} />
                                <div id="outer" className={classes.droparea}>
                                    <p id="inner" className={classes.p}>{convertBrTag(ImageDropZoneMessage)}</p>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                }
                {imageUrl && !disabled ?
                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={() => {
                            setState("")
                            setFiles(null)
                        }}>{ButtonLabelDelete}</Button> : <></>
                }
            </section>
            <aside style={{marginTop: '1em'}}>
                <img src={imageUrl} style={{width: '40%'}}/>
            </aside>
            <ErrorMessage
                errors={errors ? errors : {}}
                name={id}
                as={<Typography variant="caption" className={classes.errorMessage}/>}
            />
            <ErrorMessage
                errors={errors ? errors : {}}
                name={"sectionImageCommon"}
                as={<Typography variant="caption" className={classes.errorMessage}/>}
            />
        </React.Fragment>
    )
}

const AdAssetTextLinkItem: React.FC<{
    textLinkItem: TextLinkItem,
    setTextLinkItem: any,
    disabled: boolean,
    register: any,
    errors: any,
    index: number,
}> = ({textLinkItem, setTextLinkItem, disabled, register, errors, index}) => {

    return (
        <AdAssetCardContent
            label={`${AdAssetBoxLabel.textLink}${index}`}
            children={

                <React.Fragment>
                    <Grid container>
                        {
                            [
                                <ApolloBasicTextField
                                    id={`${AdAssetSingleItemParts.textLink.id}${index}`}
                                    label={`${AdAssetSingleItemParts.textLink.label}`}
                                    value={textLinkItem.text}
                                    multiline={true}
                                    inputRef={register({
                                        maxLength: {
                                            value: checkValueMaxLength90,
                                            message: checkMessageTextMaxLength90
                                        },
                                        validate: (value: string) => {
                                            const errorMessage = getTextStrCheckErrorMsgForTabChar(value)
                                            if(errorMessage) {
                                                return errorMessage
                                            }
                                        },
                                    })}
                                    disabled={disabled}
                                    error={errors[`${AdAssetSingleItemParts.textLink.id}${index}`]}
                                    setState={(e: any) => setTextLinkItem({...textLinkItem, text: e})}
                                    variant={"outlined"}
                                />,
                                <ApolloBasicTextField
                                    id={`${AdAssetSingleItemParts.transitionUrlForTextLink.id}${index}`}
                                    label={AdAssetSingleItemParts.transitionUrlForTextLink.label}
                                    value={textLinkItem.transitionUrl}
                                    inputRef={register({
                                        validate: (value: string) => {
                                            const errorMsg = checkUrlStrWithLength(value)
                                            if (errorMsg) {
                                                return errorMsg
                                            }
                                            return checkCommonInvalidTabChar(value);
                                        }
                                    })}
                                    disabled={disabled}
                                    error={errors[`${AdAssetSingleItemParts.transitionUrlForTextLink.id}${index}`]}
                                    setState={(e: any) => setTextLinkItem({
                                        ...textLinkItem,
                                        transitionUrl: e
                                    })}
                                />,

                            ].map((value) => {
                                return (
                                    <Grid item xs={12}>
                                        {value}
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </React.Fragment>
            }
        />
    )
}

const AdAssetTextItem: React.FC<{
    textItem: TextItem,
    setTextItem: any,
    disabled: boolean,
    register: any,
    errors: any,
}> = ({textItem, setTextItem, disabled, register, errors}) => {

    return (
        <AdAssetCardContent
            label={AdAssetBoxLabel.textLong}
            children={
                <React.Fragment>
                    <Grid container>
                        {
                            [
                                <ApolloBasicTextField
                                    id={AdAssetSingleItemParts.text.id}
                                    label={AdAssetSingleItemParts.text.label}
                                    value={textItem.text}
                                    multiline={true}
                                    inputRef={register({
                                        maxLength: {
                                            value: checkValueMaxLength180,
                                            message: checkMessageTextMaxLength180
                                        },
                                        validate: (value: string) => {
                                            const errorMessage = getTextStrCheckErrorMsgForTabChar(value)
                                            if(errorMessage) {
                                                return errorMessage
                                            }
                                        },
                                    })}
                                    disabled={disabled}
                                    error={errors[AdAssetSingleItemParts.text.id]}
                                    setState={(e: any) => setTextItem({...textItem, text: e})}
                                    variant={"outlined"}
                                />
                            ].map((value) => {
                                return (
                                    <Grid item xs={12}>
                                        {value}
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </React.Fragment>
            }
        />
    )
}

const AdAssetLinkButtonItem: React.FC<{
    commonItems: CommonItems,
    setCommonItems: any,
    disabled: boolean,
    register: any,
    errors: any,
    control: any,
}> = ({commonItems, setCommonItems, disabled, register, errors, control}) => {

    return (
        <AdAssetCardContent
            label={AdAssetBoxLabel.linkButton}
            children={
                <React.Fragment>
                    <Grid container>
                        {
                            [
                                <ApolloBasicSelect
                                    id={AdAssetCommonItemParts.linkButtonLabel.id}
                                    label={AdAssetCommonItemParts.linkButtonLabel.label}
                                    options={options_ms_button_label}
                                    value={commonItems.buttonLinkItem.labelType}
                                    disabled={disabled}
                                    control={control}
                                    menuPlacement="top"
                                    errors={errors}
                                    setState={(e: any) => setCommonItems({
                                        ...commonItems,
                                        buttonLinkItem: {
                                            ...commonItems.buttonLinkItem,
                                            labelType: e,
                                            imageUrl: getButtonImgUrl(e, commonItems.buttonLinkItem.colorType)
                                        }
                                    })}
                                />,
                                <ApolloBasicSelect
                                    id={AdAssetCommonItemParts.linkButtonColor.id}
                                    label={AdAssetCommonItemParts.linkButtonColor.label}
                                    options={options_ms_button_color}
                                    value={commonItems.buttonLinkItem.colorType}
                                    disabled={disabled}
                                    control={control}
                                    menuPlacement="top"
                                    errors={errors}
                                    setState={(e: any) => setCommonItems({
                                        ...commonItems,
                                        buttonLinkItem: {
                                            ...commonItems.buttonLinkItem,
                                            colorType: e,
                                            imageUrl: getButtonImgUrl(commonItems.buttonLinkItem.labelType, e)
                                        }
                                    })}
                                />,
                                <ApolloBasicTextField
                                    id={AdAssetCommonItemParts.linkButtonTransitionUrl.id}
                                    label={AdAssetCommonItemParts.linkButtonTransitionUrl.label}
                                    value={commonItems.buttonLinkItem.transitionUrl}
                                    inputRef={register({
                                        validate: (value: string) => {
                                            const errorMsg = checkUrlStrWithLength(value)
                                            if (errorMsg) {
                                                return errorMsg
                                            }
                                            return checkCommonInvalidTabChar(value);
                                        }
                                    })}
                                    disabled={disabled}
                                    error={errors[AdAssetCommonItemParts.linkButtonTransitionUrl.id]}
                                    setState={(e: any) => setCommonItems({
                                        ...commonItems,
                                        buttonLinkItem: {
                                            ...commonItems.buttonLinkItem,
                                            transitionUrl: e
                                        }
                                    })}
                                />
                            ].map((value) => {
                                return (
                                    <Grid item xs={12}>
                                        {value}
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </React.Fragment>
            }
        />
    )
}


const CustomItemsContents: React.FC<{
    customItems: CustomItems,
    setState: {
        setLineColor: any,
        setSectionItems: any,
    },
    register: any,
    disabled: boolean,
    errors: any,
    control: any,
    uploadFile: {
        files: any,
        setFiles: any,
        pictureFileSizeList: any,
        setPictureFileSizeList: any,
    }
}> = ({customItems, setState, register, disabled, errors, control, uploadFile}) => {

    const sectionItmes =
        customItems.sectionItems.map((sectionItem, index, sectionItems) => {
            const sectionNo = index + 1;
            return (
                <Grid container>
                    <Grid item xs={12} style={itemStyle}>
                        <AdAssetSectionItem
                            sectionItems={sectionItems}
                            sectionItem={sectionItem}
                            setSectionItems={setState.setSectionItems}
                            disabled={disabled}
                            register={register}
                            errors={errors}
                            index={sectionNo}
                            uploadFile={uploadFile}

                        />
                    </Grid>
                </Grid>
            )
        })

    return (
        <React.Fragment>
            {
                [
                    <ApolloBasicSelect
                        id={AdAssetCustomItemParts.lineColor.id}
                        label={AdAssetCustomItemParts.lineColor.label}
                        options={options_ms_line_color}
                        value={customItems.lineColor}
                        disabled={disabled}
                        control={control}
                        errors={errors}
                        setState={(e: any) => setState.setLineColor(e)}
                    />,
                    sectionItmes
                ].map((value) => {
                    return (
                        <Grid container>
                            <Grid item xs={12} style={itemStyle}>
                                {value}
                            </Grid>
                        </Grid>
                    )
                })
            }
        </React.Fragment>
    )
}

const AdAssetSectionItem: React.FC<{
    sectionItems: SectionItem[],
    sectionItem: SectionItem,
    setSectionItems: any,
    disabled: boolean,
    register: any,
    errors: any,
    index: number,
    uploadFile: {
        files: any,
        setFiles: any,
        pictureFileSizeList: any,
        setPictureFileSizeList: any,
    }
}> = ({
          sectionItems,
          sectionItem,
          setSectionItems,
          disabled,
          register,
          errors,
          index,
          uploadFile
      }) => {

    return (
        <AdAssetCardContent
            label={`${AdAssetBoxLabel.section}${index}`}
            children={
                <React.Fragment>
                    <Grid container>
                        {
                            [
                                <AdImage
                                    id={`${AdAssetCustomItemParts.imageForSection.id}${index}`}
                                    label={AdAssetBoxLabel.image}
                                    imageUrl={sectionItem.imageUrl}
                                    setState={(e: string) => {
                                        if (e === "") {
                                            setSectionItems(fill([...sectionItems], {
                                                ...sectionItem,
                                                imageUrl: e,
                                                imageName: e,
                                            }, index - 1, index))
                                        } else {
                                            setSectionItems(fill([...sectionItems], {
                                                ...sectionItem,
                                                imageUrl: e
                                            }, index - 1, index))
                                        }
                                    }}
                                    register={register}
                                    errors={errors}
                                    disabled={disabled}
                                    setFiles={(e: any) => {
                                        uploadFile.setFiles(
                                            fill([...uploadFile.files], e, index - 1, index)
                                        )
                                        uploadFile.setPictureFileSizeList(
                                            fill([...uploadFile.pictureFileSizeList], e !== null ? e.size : 0, index - 1, index)
                                        )
                                    }}
                                />,
                                <ApolloBasicCheck
                                    id={`${AdAssetCustomItemParts.enableLineFroSection.id}${index}`}
                                    label={AdAssetCustomItemParts.enableLineFroSection.label}
                                    checked={sectionItem.enableLine}
                                    disabled={disabled}
                                    setState={(e: string) => {
                                        setSectionItems(fill([...sectionItems], {
                                            ...sectionItem,
                                            enableLine: e
                                        }, index - 1, index))
                                    }}
                                />,
                                <ApolloBasicTextField
                                    id={`${AdAssetCustomItemParts.textShortForSection.id}${index}`}
                                    label={AdAssetCustomItemParts.textShortForSection.label}
                                    value={sectionItem.shortText}
                                    multiline={true}
                                    disabled={disabled}
                                    inputRef={register({
                                        maxLength: {
                                            value: checkValueMaxLength90,
                                            message: checkMessageTextMaxLength90
                                        },
                                        validate: (value: string) => {
                                            const errorMessage = getTextStrCheckErrorMsgForTabChar(value)
                                            if(errorMessage) {
                                                return errorMessage
                                            }
                                        },
                                    })}
                                    error={errors[`${AdAssetCustomItemParts.textShortForSection.id}${index}`]}
                                    setState={(e: string) => {
                                        setSectionItems(fill([...sectionItems], {
                                            ...sectionItem,
                                            shortText: e
                                        }, index - 1, index))
                                    }}
                                    variant={"outlined"}
                                />,
                                <ApolloBasicTextField
                                    id={`${AdAssetCustomItemParts.textLongForSection.id}${index}`}
                                    label={AdAssetCustomItemParts.textLongForSection.label}
                                    value={sectionItem.largeText}
                                    multiline={true}
                                    disabled={disabled}
                                    inputRef={register({
                                        maxLength: {
                                            value: checkValueMaxLength180,
                                            message: checkMessageTextMaxLength180
                                        },
                                        validate: (value: string) => {
                                            const errorMessage = getTextStrCheckErrorMsgForTabChar(value)
                                            if(errorMessage) {
                                                return errorMessage
                                            }
                                        },
                                    })}
                                    error={errors[`${AdAssetCustomItemParts.textLongForSection.id}${index}`]}
                                    setState={(e: string) => {
                                        setSectionItems(fill([...sectionItems], {
                                            ...sectionItem,
                                            largeText: e
                                        }, index - 1, index))
                                    }}
                                    variant={"outlined"}
                                />,
                                <ApolloBasicTextField
                                    id={`${AdAssetCustomItemParts.textLinkForSection.id}${index}`}
                                    label={AdAssetCustomItemParts.textLinkForSection.label}
                                    value={sectionItem.textLink}
                                    multiline={true}
                                    disabled={disabled}
                                    inputRef={register({
                                        maxLength: {
                                            value: checkValueMaxLength90,
                                            message: checkMessageTextMaxLength90
                                        },
                                        validate: (value: string) => {
                                            const errorMessage = getTextStrCheckErrorMsgForTabChar(value)
                                            if(errorMessage) {
                                                return errorMessage
                                            }
                                        },
                                    })}
                                    error={errors[`${AdAssetCustomItemParts.textLinkForSection.id}${index}`]}
                                    setState={(e: string) => {
                                        setSectionItems(fill([...sectionItems], {
                                            ...sectionItem,
                                            textLink: e
                                        }, index - 1, index))
                                    }}
                                    variant={"outlined"}
                                />,
                                <ApolloBasicTextField
                                    id={`${AdAssetCustomItemParts.transitionUrlForSection.id}${index}`}
                                    label={AdAssetCustomItemParts.transitionUrlForSection.label}
                                    value={sectionItem.transitionUrl}
                                    error={errors[`${AdAssetCustomItemParts.transitionUrlForSection.id}${index}`]}
                                    disabled={disabled}
                                    inputRef={register({
                                        validate: (value: string) => {
                                            const errorMsg = checkUrlStrWithLength(value)
                                            if (errorMsg) {
                                                return errorMsg
                                            }
                                            return checkCommonInvalidTabChar(value);
                                        }
                                    })}
                                    setState={(e: string) => {
                                        setSectionItems(fill([...sectionItems], {
                                            ...sectionItem,
                                            transitionUrl: e
                                        }, index - 1, index))
                                    }}/>,
                            ].map((value) => {
                                return (
                                    <Grid item xs={12} style={itemStyle}>
                                        {value}
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </React.Fragment>
            }
            expandOption={{
                isOpen: sectionItem.isOpen,
                setState: (() => {
                    setSectionItems(fill([...sectionItems], {
                        ...sectionItem,
                        isOpen: !sectionItem.isOpen
                    }, index - 1, index))
                }),
                isEdited: !isEqual({...sectionItem, isOpen: false}, initSectionItem),
            }}
        />
    )
}

const getButtonImgUrl = (label: string, color: string) => {
    return label && color ? `${process.env.REACT_APP_MY_ENDPOINT}/img/ms/linkButtonImg/${label}/${color}.gif` : ""
}

const getNewSectionItems = ((sectionItems: SectionItem[]) => {
    return (
        sectionItems.map((sectionItem, index) => {
            return (
                index === 0 ? sectionItem :
                    isEqual(sectionItem, initSectionItem) ? sectionItem :
                        {...sectionItem, isOpen: true}
            )
        }))
})

const createUserLog = (
    apolloContex: any,
    menu: string,
    category: string,
    actionType: string,
    displayName: string,
    beforeInfo: LogRecord | null,
    afterInfo: LogRecord,
    optionMaster: {
        textPosType: any,
        labelType : any,
        colorType : any,
        lineColor : any,
    },
) => {

    const formatId = afterInfo.commonItem.formatId

    const beforeCommonItem = beforeInfo?.commonItem ?? null
    const beforeImageItem = beforeInfo?.imageItem ?? null
    const beforeTextLinkItem1 = beforeInfo?.textLinkItem1 ?? null
    const beforeTextItem = beforeInfo?.textItem ?? null
    const beforeTextLinkItem2 = beforeInfo?.textLinkItem2 ?? null
    const beforeLineColor = beforeInfo?.lineColor ?? null
    const beforeSectionItems = beforeInfo?.sectionItems ?? null
    const beforePictureFiles = beforeInfo?.pictureFiles ?? null
    const {
        commonItem: afterCommonItem,
        imageItem: afterImageItem,
        textLinkItem1: afterTextLinkItem1,
        textItem: afterTextItem,
        textLinkItem2: afterTextLinkItem2,
        lineColor: afterLineColor,
        sectionItems: afterSectionItems,
        pictureFiles: afterPictureFiles,
    } = afterInfo

    const itemsCommon: ItemList[] = [
        createUserLogItemListFromString("広告アセット名", "assetName", beforeCommonItem, afterCommonItem),
        createUserLogItemListFromString("件名", "subject", beforeCommonItem, afterCommonItem),
        createUserLogItemListFromRadioValues("フォーマット種別", "formatId", beforeCommonItem, afterCommonItem, [
            {label: AdAssetLabelFormatId.single, value: AdAssetFormatId.single},
            {label: AdAssetLabelFormatId.custom, value: AdAssetFormatId.custom}
        ]),
        createUserLogItemListFromOptionValue("テキスト表示位置", "textPosType", beforeCommonItem, afterCommonItem, optionMaster.textPosType),
        createUserLogItemListFromOptionValue("リンクボタン_表示ラベル", "labelType", beforeCommonItem?.buttonLinkItem ?? null, afterCommonItem.buttonLinkItem, optionMaster.labelType),
        createUserLogItemListFromOptionValue("リンクボタン_カラー", "colorType", beforeCommonItem?.buttonLinkItem ?? null, afterCommonItem.buttonLinkItem, optionMaster.colorType),
        createUserLogItemListFromString("リンクボタン_遷移先URL", "transitionUrl", beforeCommonItem?.buttonLinkItem ?? null, afterCommonItem.buttonLinkItem),
        createUserLogItemListFromString("主体者表記", "notation", beforeCommonItem, afterCommonItem),
    ]

    const itemsSingle: ItemList[] = formatId === AdAssetFormatId.single ? [
        createUserLogItemListFromPictureFile("画像_ファイル名", 0, beforeImageItem, afterImageItem, afterPictureFiles),
        createUserLogItemListFromString("画像_遷移先URL", "transitionUrl", beforeImageItem, afterImageItem),
        createUserLogItemListFromString("テキストリンク１_テキスト", "text", beforeTextLinkItem1, afterTextLinkItem1),
        createUserLogItemListFromString("テキストリンク１_遷移先URL", "transitionUrl", beforeTextLinkItem1, afterTextLinkItem1),
        createUserLogItemListFromString("テキストリンク２_テキスト", "text", beforeTextLinkItem2, afterTextLinkItem2),
        createUserLogItemListFromString("テキストリンク２_遷移先URL", "transitionUrl", beforeTextLinkItem2, afterTextLinkItem2),
        createUserLogItemListFromString("テキスト本文_テキスト（本文）", "text", beforeTextItem, afterTextItem),
    ] : []

    const itemsCustom: ItemList[] = formatId === AdAssetFormatId.custom ? [
        createUserLogItemListFromOptionValue("ラインの色", BLANK, beforeLineColor, afterLineColor, optionMaster.lineColor),

        createUserLogItemListFromPictureFile("セクション１_ファイル名", 0, beforeSectionItems?.[0] ?? null, afterSectionItems?.[0], afterPictureFiles),
        createUserLogItemListFromCheck("セクション１_ライン設定有無", "enableLine", beforeSectionItems?.[0] ?? null, afterSectionItems[0]),
        createUserLogItemListFromString("セクション１_テキスト（短文）", "shortText", beforeSectionItems?.[0] ?? null, afterSectionItems[0]),
        createUserLogItemListFromString("セクション１_テキスト（長文）", "largeText", beforeSectionItems?.[0] ?? null, afterSectionItems[0]),
        createUserLogItemListFromString("セクション１_テキストリンク", "textLink", beforeSectionItems?.[0] ?? null, afterSectionItems[0]),
        createUserLogItemListFromString("セクション１_遷移先URL", "transitionUrl", beforeSectionItems?.[0] ?? null, afterSectionItems[0]),

        createUserLogItemListFromPictureFile("セクション２_ファイル名", 1, beforeSectionItems?.[1] ?? null, afterSectionItems?.[1], afterPictureFiles),
        createUserLogItemListFromCheck("セクション２_ライン設定有無", "enableLine", beforeSectionItems?.[1] ?? null, afterSectionItems[1]),
        createUserLogItemListFromString("セクション２_テキスト（短文）", "shortText", beforeSectionItems?.[1] ?? null, afterSectionItems[1]),
        createUserLogItemListFromString("セクション２_テキスト（長文）", "largeText", beforeSectionItems?.[1] ?? null, afterSectionItems[1]),
        createUserLogItemListFromString("セクション２_テキストリンク", "textLink", beforeSectionItems?.[1] ?? null, afterSectionItems[1]),
        createUserLogItemListFromString("セクション２_遷移先URL", "transitionUrl", beforeSectionItems?.[1] ?? null, afterSectionItems[1]),

        createUserLogItemListFromPictureFile("セクション３_ファイル名", 2, beforeSectionItems?.[2] ?? null, afterSectionItems?.[2], afterPictureFiles),
        createUserLogItemListFromCheck("セクション３_ライン設定有無", "enableLine", beforeSectionItems?.[2] ?? null, afterSectionItems[2]),
        createUserLogItemListFromString("セクション３_テキスト（短文）", "shortText", beforeSectionItems?.[2] ?? null, afterSectionItems[2]),
        createUserLogItemListFromString("セクション３_テキスト（長文）", "largeText", beforeSectionItems?.[2] ?? null, afterSectionItems[2]),
        createUserLogItemListFromString("セクション３_テキストリンク", "textLink", beforeSectionItems?.[2] ?? null, afterSectionItems[2]),
        createUserLogItemListFromString("セクション３_遷移先URL", "transitionUrl", beforeSectionItems?.[2] ?? null, afterSectionItems[2]),

        createUserLogItemListFromPictureFile("セクション４_ファイル名", 3, beforeSectionItems?.[3] ?? null, afterSectionItems?.[3], afterPictureFiles),
        createUserLogItemListFromCheck("セクション４_ライン設定有無", "enableLine", beforeSectionItems?.[3] ?? null, afterSectionItems[3]),
        createUserLogItemListFromString("セクション４_テキスト（短文）", "shortText", beforeSectionItems?.[3] ?? null, afterSectionItems[3]),
        createUserLogItemListFromString("セクション４_テキスト（長文）", "largeText", beforeSectionItems?.[3] ?? null, afterSectionItems[3]),
        createUserLogItemListFromString("セクション４_テキストリンク", "textLink", beforeSectionItems?.[3] ?? null, afterSectionItems[3]),
        createUserLogItemListFromString("セクション４_遷移先URL", "transitionUrl", beforeSectionItems?.[3] ?? null, afterSectionItems[3]),
    ] : []

    const retObj = createLogDate(
        apolloContex,
        menu,
        category,
        actionType === AdGroupProcessType.create ? "作成" : (actionType === AdProcessType.edit ?　"更新" : "複製"),
        displayName,
        itemsCommon.concat(itemsSingle).concat(itemsCustom),
    )

    return retObj
}

export default AdAssetsEdit
